module.exports = __webpack_public_path__ + "static/media/iq.30dee028.svg";